import qs from 'query-string'
import {useEffect} from 'react'
import {useLocation} from 'react-router'

export function Debug() {
  const {search} = useLocation()
  const {debug = ''} = qs.parse(search)
  useEffect(() => {
    // 测试环境或 debug=1 时展示 vconsole
    if (ENV !== 'production' || Number(debug) === 1) {
      import('vconsole').then((res) => {
        const Vconsole = res.default
        // eslint-disable-next-line no-new
        new Vconsole()
      })
    }
  }, [])
  return null
}
